//react...
import React from "react";

//styles...
import "./AboutPage.styles.css";
import aboutImage from "../../assets/about/about_01.jpeg";

//react-bootstrap
import { Card, Col, Container, Row } from "react-bootstrap";

const AboutPage = () => {
  return (
    <Container>
      <Card border="danger" className="mt-3">
        <Card.Header>About Us</Card.Header>
        <Row>
          <Col lg={6}>
            <Card.Img variant="end" src={aboutImage} className="about-image" />
          </Col>
          <Col lg={6}>
            <Card.Body>
              <Card.Text as="span">
                <p className="about-typo">
                  &#9726; Armco Trading Machinery Manufacturing & Distribution
                  Company has one of the experienced teams knowledgeable in road
                  construction machinery such as roller, paver, asphalt plant,
                  drilling machines and road marking machinery, by having about
                  20 yeas eye-catching experience in machinery market.
                </p>
                <p className="about-typo">
                  &#9726; During these brilliant years, founders of this company
                  have imported the best and the most up-to-date construction
                  equipment from Europe and served the best after sale services
                  and customer support.
                </p>

                <p className="about-typo">
                  &#9726; Our team uses all its attempts to promote quality of
                  executing construction project and play the best role in our
                  local Construction Industry.
                </p>

                <p className="about-typo">
                  &#9726; Armco Trading professional team has a determined goal to
                  coordinate with top brands of road construction machinery in
                  all over the world.
                </p>
              </Card.Text>
            </Card.Body>
          </Col>
        </Row>
      </Card>
    </Container>
  );
};

export default AboutPage;
